"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Client = exports.FourPDAClient = void 0;
const emitter_1 = require("./emitter");
const auth_1 = require("./services/auth");
const site_1 = require("./services/site");
const forum_1 = require("./services/forum");
const qms_1 = require("./services/qms");
const ticket_1 = require("./services/ticket");
const devdb_1 = require("./services/devdb");
const favorite_1 = require("./services/favorite");
const profile_1 = require("./services/profile");
const bookmark_1 = require("./services/bookmark");
const sync_1 = require("./services/sync");
const attachment_1 = require("./services/attachment");
const notification_1 = require("./services/notification");
const search_1 = require("./services/search");
const pushEvents_1 = require("./utils/pushEvents");
class FourPDAClient extends emitter_1.UniversalEmitter {
    constructor(transport, logger) {
        super();
        this.transport = transport;
        if (logger && this.transport.setLogger) {
            this.transport.setLogger(logger);
        }
        this.auth = new auth_1.AuthService(transport);
        this.transport.on('connected', () => {
            this.emit('connected');
            this.auth.restoreSession().catch(e => {
                const msg = '[Client] Session restoration failed';
                logger ? logger.error(msg, e) : console.error(msg, e);
            });
        });
        this.transport.on('disconnected', () => {
            this.emit('disconnected');
        });
        this.transport.on('error', (err) => {
            this.emit('error', err);
        });
        this.transport.on('message', (msg) => {
            const wire = msg;
            if (wire.id === 0 || wire.id === 30309 || wire.id === 28773 || wire.id === 29285) {
                const parsed = (0, pushEvents_1.parseFourPDAEvent)(wire);
                if (parsed) {
                    this.emit('event', parsed);
                }
            }
        });
    }
    get qms() {
        return this._qms ?? (this._qms = new qms_1.QmsService(this.transport, this.auth));
    }
    get forum() {
        return this._forum ?? (this._forum = new forum_1.ForumService(this.transport, this.auth));
    }
    get site() {
        return this._site ?? (this._site = new site_1.SiteService(this.transport));
    }
    get ticket() {
        return this._ticket ?? (this._ticket = new ticket_1.TicketService(this.transport));
    }
    get devdb() {
        return this._devdb ?? (this._devdb = new devdb_1.DevDbService(this.transport, this.auth));
    }
    get favorite() {
        return this._favorite ?? (this._favorite = new favorite_1.FavoriteService(this.transport, this.auth));
    }
    get bookmark() {
        return this._bookmark ?? (this._bookmark = new bookmark_1.BookmarkService(this.transport, this.auth));
    }
    get profile() {
        return this._profile ?? (this._profile = new profile_1.ProfileService(this.transport, this.auth));
    }
    get sync() {
        return this._sync ?? (this._sync = new sync_1.SyncService(this.transport, this.auth));
    }
    get attachment() {
        return this._attachment ?? (this._attachment = new attachment_1.AttachmentService(this.transport, this.auth));
    }
    get notifications() {
        return this._notifications ?? (this._notifications = new notification_1.NotificationService(this.transport));
    }
    get search() {
        return this._search ?? (this._search = new search_1.SearchService(this.transport));
    }
    async connect(url) {
        return this.transport.connect(url);
    }
    isConnected() {
        return this.transport.isConnected();
    }
    disconnect() {
        return this.transport.disconnect();
    }
}
exports.FourPDAClient = FourPDAClient;
exports.Client = FourPDAClient;
